import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout,  } from '@shopify/polaris';
import { BasicTextField } from '@presentational';

import { tAttribute } from '@utils';


const propTypes = {
  src: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  actions: PropTypes.array,
  open: PropTypes.bool,
};

const defaultProps = {
  actions: []
}


const VariantModal = (props) => {
  return(
    <Modal
      title="Vista previa"
      large
      open={props.open}
      onClose={props.onClose}
      secondaryActions={[
        { 
          content: I18n.t("actions.close"),
          onAction: props.onClose
        },
        ...props.actions
      ]
    }
    >
      <Modal.Section>
        <div className="flex justifyCenter alignItemsCenter">
          <img style={{ maxWidth: "100%" }} src={ props.src } />
        </div>
      </Modal.Section>
    </Modal>
  );
}

VariantModal.propTypes = propTypes;
VariantModal.defaultProps = defaultProps;


export default VariantModal;
